export const enum EditReservationEnum {
    Reservation = 1,
    Billing = 2,
    Notes = 3,
    History = 4,
    Survey = 5,
    Route = 6,
    Claims = 7,
    EncounterHistory = 8
}



// WEBPACK FOOTER //
// ./src/app/core/enums/tabs-edit-reservation.enum.ts